import React from "react";
import { useTranslation } from "react-i18next";

import icon1 from "../../../resources/assets/icon1.png";
import icon2 from "../../../resources/assets/icon2.png";
import icon3 from "../../../resources/assets/icon3.png";
import icon4 from "../../../resources/assets/icon4.png";
import Form from "./Form";

const ContactUs = () => {
  const { t } = useTranslation("home");

  return (
    <div className="bg-white rounded-xl overflow-hidden m-8 text-center space-y-4">
      <div className="bg-emerald-600 p-4 text-white text-sm">
        {t("contactUs.banner")}
      </div>

      <div className="text-sm">{t("contactUs.afterBooking")}</div>

      <div className="mx-auto w-4/5 flex justify-evenly">
        <div className="pb-2 px-2 rounded-xl border-2 border-emerald-600">
          <img src={icon1} alt="graph" />
          <div className="text-xs text-emerald-600">
            {t("contactUs.benefits.eval")}
          </div>
        </div>

        <div className="pb-2 px-2 rounded-xl border-2 border-emerald-600">
          <img src={icon2} alt="graph" />
          <div className="text-xs text-emerald-600">
            {t("contactUs.benefits.qa")}
          </div>
        </div>

        <div className="pb-2 px-2 rounded-xl border-2 border-emerald-600">
          <img src={icon3} alt="graph" />
          <div className="text-xs text-emerald-600">
            {t("contactUs.benefits.reading")}
          </div>
        </div>

        <div className="pb-2 px-2 rounded-xl border-2 border-emerald-600">
          <img src={icon4} alt="graph" />
          <div className="text-xs text-emerald-600">
            {t("contactUs.benefits.resources")}
          </div>
        </div>
      </div>

      <Form />

      <p className="ml-4 text-xs text-gray-400">
        {t("contactUs.privacy")}
      </p>
    </div>
  );
};

export default ContactUs;
